import { ReactNode } from 'react'

interface PopupHeaderProps {
	title: string | ReactNode
	onClose: () => void
}

const PopupHeader: React.FC<PopupHeaderProps> = ({ title, onClose }) => {
	return (
		<div className="flex shrink-0 justify-between items-center border-b border-[hsl(var(--border))] px-4 py-3 sm:px-5">
			<h3 className="text-lg font-semibold text-[hsl(var(--foreground))]">{title}</h3>
			<button
				onClick={onClose}
				className="inline-flex h-9 w-9 shrink-0 items-center justify-center rounded-md text-[hsl(var(--muted-foreground))] transition-colors hover:bg-[hsl(var(--muted))] hover:text-[hsl(var(--foreground))]"
				type="button"
				aria-label="Close"
			>
				<i className="ri-close-line text-2xl" />
			</button>
		</div>
	)
}

export default PopupHeader
